import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getSystemConfig, setSystemConfig } from "@/api/system";
import { emailTest } from "@/api/email";
export default {
  name: "Config",
  data: function data() {
    return {
      config: {
        system: {},
        jwt: {},
        casbin: {},
        redis: {},
        local: {},
        qiniu: {},
        minio: {},
        aliyun: {},
        captcha: {},
        email: {}
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.initForm();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initForm: function initForm() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getSystemConfig();
            case 2:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.config = res.data.config;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    reload: function reload() {},
    update: function update() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return setSystemConfig({
                config: _this3.config
              });
            case 2:
              res = _context3.sent;
              if (!(res.code == 0)) {
                _context3.next = 7;
                break;
              }
              _this3.$message({
                type: "success",
                message: "配置文件设置成功"
              });
              _context3.next = 7;
              return _this3.initForm();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    email: function email() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return emailTest();
            case 2:
              res = _context4.sent;
              if (!(res.code == 0)) {
                _context4.next = 9;
                break;
              }
              _this4.$message({
                type: "success",
                message: "邮件发送成功"
              });
              _context4.next = 7;
              return _this4.initForm();
            case 7:
              _context4.next = 10;
              break;
            case 9:
              _this4.$message({
                type: "error",
                message: "邮件发送失败"
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};